import { CropImage } from '../components/CropImage';

interface CropImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (blob: Blob) => void;
  base64Image: string;
}

export function CropImageModal({
  isOpen,
  onClose,
  onSave,
  base64Image,
}: CropImageModalProps) {
  return (
    <CropImage
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      base64Image={base64Image}
    />
  );
}

export type { CropImageModalProps };
